import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
} from '@mui/material';
import { UPDATE_BREAK_RULE_SET } from '../../../store/ruleSet';
import BreakCalculation from './BreakCalculation';

/**
 * @param {{validationErrors: {[Key: string] : boolean, isDisabled: boolean }, isDisabled: boolean, stepNumber: number}} props
 */
export default function BreakRuleSection(props) {
    const { validationErrors, isDisabled, stepNumber, } = props;
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.breakRuleStep' });
    const dispatch = useDispatch();
    /** @type {RuleSet.IRuleSetDetails} */
    const adminRuleSet = useSelector((/** @type {EmploymentBillboard.AdminStore} */ state) => state.adminRuleSet);

    /**
     * @param {string} target
     * @param {string} value
     */
    const updateBreakRulesStore = (target, value) => {
        dispatch({
            type: UPDATE_BREAK_RULE_SET,
            payload: {
                [target]: value,
            },
        });
    };

    const generateErrorMessage = (errorKey) => {
        return validationErrors[errorKey] && (
          <span style={{ color: 'red', display: 'block' }}>{t(errorKey)}</span>
        );
    };

    return (
        <Card className="card">
            <CardHeader
                className="card--header"
                titleTypographyProps={{ gutterBottom: true }}
                avatar={<Avatar className="avatar">{stepNumber}</Avatar>}
                title={t('title')}
            />
            <CardContent>
                <BreakCalculation 
                    breakRules={adminRuleSet.breakRules}
                    handleChangeSetting={updateBreakRulesStore}
                    disabled={isDisabled}
                />
                {generateErrorMessage('noBreakRuleCondition')}
                {generateErrorMessage('noBreakRuleSameConditionAndShiftDuration')}
            </CardContent>
        </Card>

    );
}
